"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var AppTemplateEditor_module_css_1 = __importDefault(require("./AppTemplateEditor.module.css"));
var react_i18next_1 = require("react-i18next");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var AppTemplateResourcesTab = (0, react_1.forwardRef)(function (_a, ref) {
    var appTemplateData = _a.appTemplateData, onResourcesUpdate = _a.onResourcesUpdate;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var logger = q_play_core_1.logManager.getLogger();
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var _b = (0, react_1.useState)(appTemplateData.resources || {}), resources = _b[0], setResources = _b[1];
    var _c = (0, react_1.useState)(null), editingResourceKey = _c[0], setEditingResourceKey = _c[1];
    var _d = (0, react_1.useState)(false), snackbarOpen = _d[0], setSnackbarOpen = _d[1];
    var _e = (0, react_1.useState)(""), snackbarMessage = _e[0], setSnackbarMessage = _e[1];
    var _f = (0, react_1.useState)("success"), snackbarSeverity = _f[0], setSnackbarSeverity = _f[1];
    var _g = (0, react_1.useState)({
        key: "",
        label: "",
        template: "",
        resources: {}
    }), editedValues = _g[0], setEditedValues = _g[1];
    var _h = (0, react_1.useState)(new Set()), newUnsavedResources = _h[0], setNewUnsavedResources = _h[1];
    var getNextResourceNumber = function () {
        var existingKeys = Object.keys(resources);
        var newResourceNumbers = existingKeys
            .filter(function (key) { return key.startsWith("new-resource-"); })
            .map(function (key) {
            var num = parseInt(key.replace("new-resource-", ""));
            return isNaN(num) ? 0 : num;
        });
        if (newResourceNumbers.length === 0)
            return 1;
        return Math.max.apply(Math, newResourceNumbers) + 1;
    };
    var handleAddResource = function () {
        var _a, _b;
        setEditingResourceKey(null);
        var nextNumber = getNextResourceNumber();
        var newResourceKey = "new-resource-".concat(nextNumber);
        var newResource = {
            label: "New Resource",
            template: "",
            resources: (_a = {},
                _a[newResourceKey] = {
                    label: "New Resource Item",
                    script: "",
                    resource: ""
                },
                _a)
        };
        var updatedResources = __assign(__assign({}, resources), (_b = {}, _b[newResourceKey] = newResource, _b));
        setNewUnsavedResources(function (prev) {
            var updated = new Set(prev);
            updated.add(newResourceKey);
            return updated;
        });
        setResources(updatedResources);
        onResourcesUpdate(updatedResources);
        setEditedValues({
            key: newResourceKey,
            label: newResource.label,
            template: newResource.template,
            resources: newResource.resources
        });
        setEditingResourceKey(newResourceKey);
    };
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        handleAddResource: handleAddResource
    }); });
    var handleRemoveResource = function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var isNewUnsavedResource, updatedResources, updatedResources, error_1, msg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isNewUnsavedResource = newUnsavedResources.has(key);
                    if (isNewUnsavedResource) {
                        updatedResources = __assign({}, resources);
                        delete updatedResources[key];
                        setResources(updatedResources);
                        onResourcesUpdate(updatedResources);
                        setNewUnsavedResources(function (prev) {
                            var updated = new Set(prev);
                            updated.delete(key);
                            return updated;
                        });
                        if (editingResourceKey === key) {
                            setEditingResourceKey(null);
                        }
                        setSnackbarMessage("Resource removed");
                        setSnackbarSeverity("success");
                        setSnackbarOpen(true);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dataProvider.deleteTemplateResource(appTemplateData.id, appTemplateData.version, key)];
                case 2:
                    _a.sent();
                    updatedResources = __assign({}, resources);
                    delete updatedResources[key];
                    setResources(updatedResources);
                    onResourcesUpdate(updatedResources);
                    if (editingResourceKey === key) {
                        setEditingResourceKey(null);
                    }
                    setSnackbarMessage("Resource deleted successfully");
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    msg = error_1.message || "Unknown error";
                    setSnackbarMessage("Failed to delete resource: ".concat(msg));
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    logger.error("Failed to remove resource:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleEditClick = function (key) {
        if (editingResourceKey === key) {
            setEditingResourceKey(null);
        }
        else {
            setEditingResourceKey(key);
            setEditedValues({
                key: key,
                label: resources[key].label,
                template: resources[key].template,
                resources: __assign({}, resources[key].resources)
            });
        }
    };
    var isFormValid = function () {
        if (!editedValues.key || !editedValues.label || !editedValues.template) {
            return false;
        }
        return Object.values(editedValues.resources).every(function (resource) { return resource.label && resource.script && resource.resource; });
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var originalKey, newKey, isNew, keyChanged, subResourceData, updatedSubResources, updatedResources, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isFormValid())
                        return [2 /*return*/];
                    if (!editingResourceKey) {
                        setSnackbarMessage("No resource is currently being edited");
                        setSnackbarSeverity("error");
                        setSnackbarOpen(true);
                        return [2 /*return*/];
                    }
                    originalKey = editingResourceKey;
                    newKey = editedValues.key;
                    isNew = newUnsavedResources.has(originalKey);
                    keyChanged = originalKey !== newKey;
                    if (keyChanged && resources[newKey]) {
                        setSnackbarMessage("A resource with this key already exists");
                        setSnackbarSeverity("error");
                        setSnackbarOpen(true);
                        return [2 /*return*/];
                    }
                    subResourceData = Object.values(editedValues.resources)[0];
                    updatedSubResources = (_a = {},
                        _a[newKey] = subResourceData,
                        _a);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dataProvider.createTemplateResource(appTemplateData.id, appTemplateData.version, newKey, {
                            label: editedValues.label,
                            template: editedValues.template,
                            resources: updatedSubResources
                        }, isNew
                            ? undefined
                            : {
                                isUpdate: true,
                                originalKey: originalKey
                            })];
                case 2:
                    _b.sent();
                    updatedResources = __assign({}, resources);
                    if (keyChanged) {
                        delete updatedResources[originalKey];
                    }
                    updatedResources[newKey] = {
                        label: editedValues.label,
                        template: editedValues.template,
                        resources: updatedSubResources
                    };
                    setResources(updatedResources);
                    onResourcesUpdate(updatedResources);
                    if (isNew) {
                        setNewUnsavedResources(function (prev) {
                            var updated = new Set(prev);
                            updated.delete(originalKey);
                            updated.add(newKey);
                            return updated;
                        });
                    }
                    setEditingResourceKey(null);
                    setSnackbarMessage("Resource saved successfully");
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _b.sent();
                    logger.error("Failed to save resource:", error_2);
                    setSnackbarMessage("Failed to save resource");
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleInputChange = function (field, value) {
        setEditedValues(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = value, _a)));
        });
    };
    var handleSubResourceChange = function (resourceKey, field, value) {
        setEditedValues(function (prev) {
            var _a, _b;
            return (__assign(__assign({}, prev), { resources: __assign(__assign({}, prev.resources), (_a = {}, _a[resourceKey] = __assign(__assign({}, prev.resources[resourceKey]), (_b = {}, _b[field] = value, _b)), _a)) }));
        });
    };
    return (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resources-container"] },
        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resources-grid"] }, Object.entries(resources).map(function (_a) {
            var key = _a[0], resource = _a[1];
            return (react_1.default.createElement("div", { key: key, className: AppTemplateEditor_module_css_1.default["resource-card"] },
                react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-card-header"] },
                    editingResourceKey === key ? (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["edit-resource-header"] },
                        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field"] },
                            react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-label"] }, "Key:"),
                            react_1.default.createElement(q_play_components_1.Input, { value: editedValues.key, onChange: function (e) { return handleInputChange("key", e.target.value); }, style: { width: "100%" } })),
                        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field"] },
                            react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-label"] }, "Label:"),
                            react_1.default.createElement(q_play_components_1.Input, { value: editedValues.label, onChange: function (e) { return handleInputChange("label", e.target.value); }, style: { width: "100%" } })))) : (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-title-container"] },
                        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-key"] }, key),
                        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-title"] }, resource.label))),
                    react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-actions"] },
                        react_1.default.createElement("button", { className: AppTemplateEditor_module_css_1.default["edit-button"], onClick: function () { return handleEditClick(key); } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faPen, style: {
                                    color: editingResourceKey === key ? "var(--primary-color)" : "inherit"
                                } })),
                        react_1.default.createElement("button", { className: AppTemplateEditor_module_css_1.default["delete-button"], onClick: function () { return handleRemoveResource(key); } },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, style: { color: "var(--error-color)" } })))),
                react_1.default.createElement("div", { className: "".concat(AppTemplateEditor_module_css_1.default["resource-card-content"], " ").concat(editingResourceKey === key ? AppTemplateEditor_module_css_1.default["resource-card-content-editing"] : "") },
                    react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field"] },
                        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-label"] }, "Template:"),
                        editingResourceKey === key ? (react_1.default.createElement(q_play_components_1.Input, { value: editedValues.template, onChange: function (e) { return handleInputChange("template", e.target.value); }, style: { width: "100%" } })) : (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-value"] }, resource.template))),
                    react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-section"] },
                        react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-section-title"] }, "Resources:"),
                        Object.entries(editingResourceKey === key ? editedValues.resources : resource.resources).map(function (_a) {
                            var subKey = _a[0], subResource = _a[1];
                            return (react_1.default.createElement("div", { key: subKey, className: AppTemplateEditor_module_css_1.default["sub-resource"] },
                                react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field"] },
                                    react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-label"] }, "Label:"),
                                    editingResourceKey === key ? (react_1.default.createElement(q_play_components_1.Input, { value: subResource.label, onChange: function (e) { return handleSubResourceChange(subKey, "label", e.target.value); }, style: { width: "100%" } })) : (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-value"] }, subResource.label))),
                                react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field"] },
                                    react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-label"] }, "Script:"),
                                    editingResourceKey === key ? (react_1.default.createElement(q_play_components_1.Input, { value: subResource.script, onChange: function (e) { return handleSubResourceChange(subKey, "script", e.target.value); }, style: { width: "100%" } })) : (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-value"] }, subResource.script))),
                                react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field"] },
                                    react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-label"] }, "Resource:"),
                                    editingResourceKey === key ? (react_1.default.createElement(q_play_components_1.Input, { value: subResource.resource, onChange: function (e) { return handleSubResourceChange(subKey, "resource", e.target.value); }, style: { width: "100%" } })) : (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-field-value"] }, subResource.resource)))));
                        }))),
                editingResourceKey === key && (react_1.default.createElement("div", { className: AppTemplateEditor_module_css_1.default["resource-card-footer"] },
                    react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), variant: "primary", size: "small", onClick: handleSave, disabled: !isFormValid() })))));
        })),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: snackbarSeverity, snackbarStyle: { marginTop: "95px" } })));
});
AppTemplateResourcesTab.displayName = "AppTemplateResourcesTab";
exports.default = AppTemplateResourcesTab;
